// src/pages/WorkerSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const WorkerSupport: React.FC = () => <CategoryPage categoryId="worker" art="documents" />;

export default WorkerSupport;
